<template>
  <v-app class="scroll">
    <div v-if="dialog">
      <v-dialog
        class="elevation-0"
        v-model="dialog"
        width="100%"
        transition="dialog-bottom-transition"
      >
        <requirement-edit
          @close="dialog = false"
          v-if="this.htmlComponent == 'requirement-edit'"
          :value="this.DocEntry"
        ></requirement-edit>
        <order-purchase-edit
          @onClose="dialog = false"
          v-if="this.htmlComponent == 'orderpurchase-edit'"
          :value="this.DocEntry"
          :typeOrder="1"
          :order="{}"
        ></order-purchase-edit>
        <AdvanceDetail
          @close="dialog = false"
          v-if="this.htmlComponent == 'advance-detail'"
          :value="this.DocEntry"
        >
        </AdvanceDetail>
        <hmn-staffing-requirement-detail
          @close="dialog = false"
          v-if="this.htmlComponent == 'staffing-requirement-detail'"
          :reqID="this.DocEntry"
        ></hmn-staffing-requirement-detail>
      </v-dialog>
    </div>
    <div v-if="dialogNotification">
      <v-dialog
        class="elevation-0"
        v-model="dialogNotification"
        width="80%"
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <s-notification />
      </v-dialog>
    </div>
    <v-navigation-drawer
      v-if="!$route.meta.fullScreenLayout"
      class="scroll"
      app
      clipped
      v-model="drawer"
      fixed
      mobile-breakpoint=""
      width="320"
      bottom
      :temporary="$vuetify.breakpoint.xs"
      :color="bck_navigation"
      hide-overlay
      :dark="darkMode"
      style="
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100vh;
        top: 35px;
      "
    >
      <v-treeview
        class="scroll"
        dense
        @update:active="updateMenu"
        @update:open="openMenu($event)"
        :items="userMenu"
        transition
        item-text="OptName"
        item-id="OptID"
        item-key="OptCode"
        item-children="SecOptionChild"
        open-on-click
        activatable
        off-icon="ds"
        on-icon=""
        :color="opt_nav"
        :style="opt_stylenav"
      >
        <template v-slot:prepend="{ item }">
          <v-icon x-small v-text="item.OptIcon"></v-icon>
        </template>
      </v-treeview>
      <!-- Slider de imágenes -->
      <!-- <div>
          <div>
            <img
                lazy="loading"
                src="@/assets/sliderImagen1.jpg"
                max-width="50vh"
                max-height="62h"
                class="d-flex justify-center align-center"
                style="margin-bottom: 0; margin-top: 10px; border: 5px solid #FFFFFF; width: 100%; height: auto;"
                @click="dialogImg=true"
              />
          </div>
        </div> -->
      <div class="slider-container">
        <div
          @mouseover="pauseSlider"
          @mouseleave="resumeSlider"
          class="slider-wrapper"
          :class="{ 'video-active': images[currentIndex]?.isVideo }"
        >
          <transition-group name="slide" tag="div" class="slider">
            <template v-for="(image, index) in images">
              <v-img
                v-if="index === currentIndex && !image.isVideo"
                :key="'img-' + index"
                :src="image.src"
                alt="Slider image"
                class="slider-image"
                @click="openDialog"
                style="
                  padding: 5px;
                  background-color: #fff;
                  object-fit: contain;
                "
              />
              {{ image }}
              <video
                v-if="index === currentIndex && image.isVideo"
                :key="'video-' + index"
                :src="image.src"
                autoplay
                muted
                playsinline
                class="slider-video"
                style="width: 300px; max-height: 400px; object-fit: contain"
                @ended="!playSoloVideo && handleVideoEnded()"
              ></video>
            </template>
          </transition-group>
        </div>
      </div>

      <!-- Fin Slider de imágenes -->
    </v-navigation-drawer>
    <!-- -->
    <v-app-bar
      v-if="!$route.meta.fullScreenLayout"
      app
      clipped-left
      dense
      tile
      flat
      height="35"
      :style="
        bgHeaderSunExpertStatico == 1
          ? 'background: linear-gradient(45deg, #E22825 0%, #FF4444 50%, #E22825 100%)'
          : bck_toolbar
      "
      class="elevation-0"
      :dark="darkMode"
      style="z-index: 20"
    >
      <v-app-bar-nav-icon
        small
        @click.stop="drawer = !drawer"
        :style="icon_tlb"
      />

      <v-toolbar-title
        :class="class_styleCompany"
        class="d-flex align-center"
        style="gap: 10px; width: 100%"
      >
        <div style="display: flex; align-items: center; gap: 5px">
          <!-- <v-container class="gorro"></v-container> -->

          <div>{{ companyName }}</div>

          <v-chip x-small color="success">
            <marquee direction="left">{{ this.personNight }}</marquee>
          </v-chip>

          <!-- Componente de Semana Actual -->
          <v-tooltip bottom v-if="showWeekNumber == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                x-small
                class="week-chip-pulse ml-1"
                v-bind="attrs"
                v-on="on"
                :dark="darkMode"
                :color="
                  darkMode ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.05)'
                "
                style="border-radius: 12px"
              >
                <v-icon left x-small>mdi-calendar-week</v-icon>
                Semana {{ currentWeek }}
              </v-chip>
            </template>
            <span>Semana actual del año</span>
          </v-tooltip>
        </div>

        <!-- BLOQUE CENTRAL -->
        <div
          class="flex-grow-1 d-flex justify-center"
          v-if="sunshineExportNavidad == 1"
        >
          <christmas-countdown />
        </div>

        <!-- (Opcional) puedes dejar el lado derecho vacío o agregar más cosas -->
        <div style="width: 120px"></div>
      </v-toolbar-title>

      <!-- <v-col>
        <v-img contain
          src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/2708147a-9e73-4d2e-a640-764f7a1be2ec/d5mxuaf-44e08c01-bd7f-4920-91ce-4c3d8bb3d045.png/v1/fill/w_500,h_383,strp/gorro_de_navidad_png_by_chequealostutoriales_d5mxuaf-fullview.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzgzIiwicGF0aCI6IlwvZlwvMjcwODE0N2EtOWU3My00ZDJlLWE2NDAtNzY0ZjdhMWJlMmVjXC9kNW14dWFmLTQ0ZTA4YzAxLWJkN2YtNDkyMC05MWNlLTRjM2Q4YmIzZDA0NS5wbmciLCJ3aWR0aCI6Ijw9NTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.KWNgxPGOFOwouMuNnzGCA7TFsKsb0tGphGxNdNYf_WU"
          height="20"></v-img>
      </v-col> -->
      <v-spacer></v-spacer>

      <!-- </v-row> -->
      <v-menu
        v-model="notificationMenuOpen"
        bottom
        offset-y
        transition="slide-y-transition"
        :close-on-content-click="false"
        style="z-index: 100"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" small @click="clickNotification()">
            <v-badge
              v-if="itemsAlertPending.length > 0"
              dot
              color="error error-4"
              bottom
              left
              offset-x="5"
              offset-y="0"
            >
            </v-badge>
            <v-icon :style="icon_tlb">mdi-bell-ring-outline</v-icon>
          </v-btn>
        </template>
        <v-card style="overflow: hidden">
          <v-list class="mx-auto">
            <v-toolbar height="25" elevation="0">
              <v-toolbar-title>Notificaciones</v-toolbar-title></v-toolbar
            >
            <v-row
              ><v-col lg="6" style="margin-bottom: 12px">
                <h5
                  style="
                    color: var(--v-error-base);
                    padding-left: 16px;
                    margin-bottom: 0px;
                  "
                >
                  {{ itemsAlertPending.length }} Nuevas Notificaciones
                </h5> </v-col
              ><v-spacer></v-spacer>
              <v-col lg="3" style="">
                <!-- <a @click="dialogNotification = true">Ver todas</a>-->
              </v-col>
            </v-row>

            <div
              style="height: 500px; overflow: auto"
              class="scroll"
              @scroll="handleScroll"
            >
              <v-list-item-group
                :value="selected"
                multiple
                active-class="primary--text"
              >
                <template v-for="(item, index) in itemsAlert">
                  <v-list-item
                    dense
                    exact
                    @click="showAlert(item)"
                    :key="item.AleID"
                  >
                    <v-list-item-avatar style="overflow: unset !important">
                      <v-avatar
                        style="overflow: unset !important"
                        :color="item.AleColor"
                      >
                        <span class="white--text">{{ item.TrsAbbrTable }}</span>
                      </v-avatar>
                    </v-list-item-avatar>

                    <v-list-item-content style="padding: 0px">
                      <p style="margin-bottom: 6px">
                        <b>{{ item.AleName }}</b>
                      </p>
                      <h5 class="text--primary" style="margin-bottom: 0px">
                        <span>{{ item.AleMessage }}</span>
                      </h5>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider :key="index" :inset="true"></v-divider>
                </template>
              </v-list-item-group>
            </div>
          </v-list>
        </v-card>
      </v-menu>

      <v-btn text small :class="class_styleCompany">
        {{ usrName }}
      </v-btn>
      <v-menu
        bottom
        offset-y
        :close-on-content-click="false"
        v-model="configurationUser"
        transition="slide-y-transition"
        style="z-index: 100"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" small>
            <v-icon x-small :style="icon_tlb">fas fa-cogs</v-icon>
          </v-btn>
        </template>
        <s-configuration
          :activate="configurationUser"
          :configUser="configUser"
          :user="user"
          :personImage="personImage"
          @getBackground="getBackground($event)"
          @getToolbar="getToolbar($event)"
          @getNavigation="getNavigation($event)"
          @getReset="getReset($event)"
          @getLogout="logout($event)"
        />
      </v-menu>
    </v-app-bar>

    <v-main
      :class="[bck_main]"
      :style="
        $route.meta.fullScreenLayout
          ? 'padding:0!important;'
          : isMobile
          ? 'margin-bottom: 40px;'
          : ''
      "
    >
      <v-container
        fluid
        :style="
          $route.meta.fullScreenLayout
            ? 'padding:0!important;max-width:100%;height:100vh;'
            : 'position:relative'
        "
      >
        <div
          style="z-index: 10; position: relative"
          v-if="bgHomeFiestasPatrias == 1 && !$route.meta.fullScreenLayout"
        >
          <s-breadcrumb />
        </div>
        <div
          v-if="bgHomeFiestasPatrias == 1"
          style="
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          "
        >
          <img
            style="
              object-fit: cover;
              width: 100%;
              min-height: calc(100vh - 65px);
            "
            src="@/assets/SunExpertWallpaper2.jpg"
            alt="SunExpertWallpaper2"
          />
        </div>
        <div
          v-if="bgHomeFiestasPatrias == 1"
          style="z-index: 10; position: relative"
        >
          <router-view />
        </div>

        <div v-if="bgHomeFiestasPatrias == 0">
          <s-breadcrumb v-if="!$route.meta.fullScreenLayout" />
          <router-view />
        </div>
        <!--  <modal-time-session @exit="exit()" v-if="isIdle == true" />-->
      </v-container>
    </v-main>
    <!-- <div class="trineo-container">
      <img src="@/assets/trineo.png" alt="Trineo" class="trineo-img" />
    </div> -->

    <!-- <v-footer app padless dark :class="{ 'mobile-absolute': isMobile }" style="z-index: 100;"> -->
    <v-footer
      v-if="!$route.meta.fullScreenLayout"
      app
      padless
      dark
      style="z-index: 100"
      v-bind:absolute="isMobile"
    >
      <v-container fluid style="position: relative">
        <v-row>
          <v-col class="py-1 body-2" cols="4">
            <span>
              2020 · Equipo de desarrollo TI — Todos los derechos reservados.
            </span>
          </v-col>
          <v-col class="py-0 body-2" cols="4">
            <div class="wave"></div>
          </v-col>
          <v-col class="py-1 pr-4 text-right body-2" cols="4">
            <div
              style="
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: end;
              "
            >
              <div v-if="userSAP != null">[SAP] {{ userSAP.UssUserCode }}</div>
              <div v-else>[SAP] Sin Usuario asociado</div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <v-dialog v-model="dialogImg" max-width="60vh">
      <v-card>
        <v-img
          :src="pausedImageSrc"
          class="white--text align-center"
          max-height="100%"
          max-width="100%"
        />
        <!-- <v-btn icon @click="dialogImg=false">
          <v-icon>mdi-close</v-icon>
        </v-btn> -->
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogAlertHmnRemote"
      v-if="QuantityApproval > 0"
      persistent
      max-width="550px"
    >
      <v-card class="pa-5 rounded-xl elevation-2">
        <v-card-title
          class="headline font-weight-bold grey--text text--darken-3"
        >
          <!-- <v-icon color="orange darken-2" left class="mr-2">mdi-bell</v-icon> -->
          🔔 Notificación
        </v-card-title>

        <v-card-text class="text-body-1 grey--text text--darken-2">
          Tiene <strong>{{ QuantityApproval }}</strong> solicitudes pendientes
          de aprobación para trabajo remoto.
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text color="grey darken-1" @click="cancelRemote()">
            Cancelar
          </v-btn>
          <v-btn color="orange darken-2" dark @click="viewRemote()">
            Ver
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Floating Notifications System (Stack Mode) -->
    <div class="notif-stack-container">
      <SFloatingNotification
        v-model="dialogExpiredCertifications"
        title="Certificaciones por Vencer"
        icon="mdi-certificate"
        :items="expiredCertificationsList"
        :expanded="expandedGroup === 'certs'"
        gradient="linear-gradient(135deg, #1b5e20 0%, #43a047 100%)"
        itemTitleKey="FagName"
        itemSubtitleKey="CertNameConcat"
        itemChipKey="DaysToExpire"
        itemFooterLeftKey=""
        itemFooterRightKey="CrtDateEnd"
        :footerRightFunction="(val) => $fun.formatDateView(val)"
        :showAllButton="false"
        @update:expanded="(val) => (expandedGroup = val ? 'certs' : null)"
        @click:all="goToExpiredCertifications('all')"
        @click:item="(item) => goToExpiredCertifications(item)"
        @click:dismiss="(item) => dismissCertNotification(item)"
      />

      <SFloatingNotification
        v-model="dialogExpiredContracts"
        title="Contratos por Vencer"
        icon="mdi-file-document-edit-outline"
        :items="expiredContractsList"
        :expanded="expandedGroup === 'contracts'"
        gradient="linear-gradient(135deg, #1565C0 0%, #1E88E5 100%)"
        itemTitleKey="ProducerName"
        itemSubtitleKey="TypeProducerContractName"
        itemChipKey="DaysToExpire"
        itemFooterRightKey="EndDateContract"
        :footerRightFunction="(val) => $fun.formatDateView(val)"
        :chipColorFunction="
          (val, item) => getContractChipColor(item.statusDaysToExpire)
        "
        :showAllButton="false"
        @update:expanded="(val) => (expandedGroup = val ? 'contracts' : null)"
        @click:all="goToExpiredContracts('all')"
        @click:item="(item) => goToExpiredContracts(item)"
        @click:dismiss="(item) => dismissContractNotification(item)"
      />

      <SFloatingNotification
        v-model="dialogWeeklyProjections"
        title="Proyecciones Semanales Sincronizadas"
        icon="mdi-chart-line"
        :items="weeklyProjectionsNotificationList"
        :expanded="expandedGroup === 'projections'"
        gradient="linear-gradient(135deg, #FF8F00 0%, #FFB300 100%)"
        itemTitleKey="FagName"
        itemSubtitleKey="PdsName"
        itemChipKey="WptProjectedJabas"
        :chipTextFunction="(val) => val + ' jabas'"
        itemFooterLeftKey="FltName"
        itemFooterRightKey="CmaName"
        :showAllButton="true"
        @update:expanded="(val) => (expandedGroup = val ? 'projections' : null)"
        @click:all="goToWeeklyProjections('all')"
        @click:item="(item) => goToWeeklyProjections(item)"
        @click:dismiss="(item) => dismissProjectionNotification(item)"
      />
    </div>
  </v-app>
</template>

<script>
import _Information from "@/services/InformationTechnology/InventoryService";
import SBreadcrumb from "@/components/Layout/SBreadcrumb.vue";
import sConfiguration from "@/views/Configurations/ConfigurationTool.vue";
import sNotification from "@/views/Security/Notification.vue";
import ModalTimeSession from "@/components/Layout/ModalTimeSession";
import RequirementEdit from "@/views/Logistics/Requirement/RequirementEdit.vue";
import _sAuth from "@/services/AuthService";
import _sTransaction from "@/services/Security/AlertService";
import _sHelper from "@/services/HelperService";
import OrderPurchaseEdit from "@/views/Logistics/OrderPurchase/OrderPurchaseEdit";
import _sGenParamService from "@/services/General/ParameterService";
import AdvanceDetail from "@/views/TechnicalAssistance/AdvanceProducer/AdvanceDetail.vue";
import HmnStaffingRequirementDetail from "@/views/HumanResource/Recruitmentseleccion/HmnStaffingRequirementDetail.vue";
import ChristmasCountdown from "@/components/ChristmasCountdown.vue";

import _sWorkerAllowance from "@/services/HumanResource/WorkerAllowanceService";
import _sAttendanceRemoteService from "@/services/HumanResource/Compensation/HmnAttendanceRemoteService.js";
import _sCertificationsService from "@/services/Technicalassistance/CertificationsService";
import _sProducerContractService from "@/services/Technicalassistance/TasProducerContractService";
import _sWeeklyProjectionService from "@/services/Technicalassistance/WeeklyProjectionService";
import _sGenNotifications from "@/services/General/GenNotifications";
import SFloatingNotification from "@/components/Layout/SFloatingNotification.vue";
import { Fireworks } from "fireworks-js";
import { DateTime, Duration } from "luxon";

export default {
  components: {
    SBreadcrumb,
    ModalTimeSession,
    sConfiguration,
    RequirementEdit,
    sNotification,
    OrderPurchaseEdit,
    AdvanceDetail,
    HmnStaffingRequirementDetail,
    ChristmasCountdown,
    SFloatingNotification,
  },
  data() {
    return {
      showWeekNumber: 0,
      currentWeek: 0,
      playVideo: 0,
      playSoloVideo: 0,
      bgHeaderSunExpertStatico: 0,
      bgHomeFiestasPatrias: 0,
      fireworksInstance: null,
      indexAlert: 0,
      lengthItemsAlert: 20,
      mini: true,
      dialogNotification: false,
      notificationMenuOpen: false,
      itemsAlert: [],
      itemsAlertPending: [],
      dialog: false,
      htmlComponent: "",
      DocEntry: 0,
      selected: [],
      usrID: this.$fun.getUserID(),
      timeToken: null,
      drawer: true,
      time: 10000,
      timeInactiveShow: 0,
      usrName: "",
      personImage: null,
      user: {},
      userMenu: [],
      managerSAP: false,
      userSAP: {},
      configurationUser: false,
      configurationTOOL: {},
      isNavigation: false,
      isToolbar: false,
      isMode: false,
      bck_navigation: "",
      icon_nav: "",
      opt_nav: "",
      opt_stylenav: "",
      bck_toolbar: "",
      class_styleCompany: "style-default",
      icon_tlb: "",
      bck_main: "",
      darkMode: false,
      configUser: {},
      paramRefresh: null,
      configDefault: {
        bck_navDefault: "#E0E0E0",
        icon_navDefault: "black",
        opt_navDefault: "primary darken-1",
        opt_stylenavDefault: "black",
        bck_toolbarDefault: "#E0E0E0",
        class_styleCompanyDefault: "style-default",
        bck_tlbDefault: "#E0E0E0",
        icon_tlbDefault: "black",
        bck_Default: "background-body",
      },
      stylemodedark: "rgb(53, 54, 58)",
      baseUrl: "",
      personNight: "",
      images: [
        { src: "/static/sliderImagen1.jpg" },
        { src: "/static/sliderImagen2.jpg" },
        // { src: '/static/videoSunExpertLogin.mp4', isVideo: true },
      ],
      currentIndex: 0,
      interval: null,
      intervalTime: 10000,
      dialogImg: false,
      pausedImageSrc: null,
      dialogAlertHmnRemote: false,
      QuantityApproval: 0,
      companyName: "SUNSHINE EXPORT",
      sunshineExportHalloween: 0,
      sunshineExportNavidad: 0,
      dialogExpiredCertifications: false,
      expiredCertificationsList: [],
      dialogExpiredContracts: false,
      expiredContractsList: [],
      expandedGroup: null, // Controla qué notificación está abierta ('certs', 'contracts', etc)
      dialogWeeklyProjections: false,
      weeklyProjectionsNotificationList: [],
    };
  },
  created() {
    this.usrName = localStorage.getItem("UsrName");
    this.initialize();
    this.configurateActivity();
    this.inizializeAlerts();
    this.drawer = !this.$vuetify.breakpoint.xs;
    // this.birthday();
    this.ViewDataRemoteApproval();
    this.loadExpiredCertifications();
    this.loadExpiredContracts();
    this.loadWeeklyProjections();
  },
  methods: {
    //samir
    birthday() {
      _sWorkerAllowance.birthday({}, this.$fun.getUserID()).then((r) => {});
    },
    VerificationRemoteApproval() {
      const data = {};
      data.OptCode = "HMN_VALIDATION_REQUEST_REMOTE";
      _sWorkerAllowance
        .verificationOption(data, this.$fun.getUserID())
        .then((r) => {
          if (r.data != null) {
            this.dialogAlertHmnRemote = true;
          }
        });
    },
    ViewDataRemoteApproval() {
      _sAttendanceRemoteService
        .SeeValidations({}, this.$fun.getUserID())
        .then((r) => {
          const currentQuantity = r.data.reduce((sum, item) => {
            return sum + (item.Cantidad || 0);
          }, 0);

          this.QuantityApproval = currentQuantity;

          // Leer localStorage
          const storedQuantity = parseInt(
            localStorage.getItem(
              `hmn_remote_validation_quantity_${this.$fun.getUserID()}`,
            ) || "0",
          );

          // Si no existe o la cantidad es diferente, mostramos modal
          if (
            this.QuantityApproval > 0 &&
            this.QuantityApproval !== storedQuantity
          ) {
            this.VerificationRemoteApproval();
          }
        });
    },
    cancelRemote() {
      this.dialogAlertHmnRemote = false;
      const userID = this.$fun.getUserID();
      const key = `hmn_remote_validation_quantity_${userID}`;
      localStorage.setItem(key, this.QuantityApproval);
    },

    viewRemote() {
      this.dialogAlertHmnRemote = false;
      const userID = this.$fun.getUserID();
      const key = `hmn_remote_validation_quantity_${userID}`;
      localStorage.setItem(key, this.QuantityApproval);
      this.$router.push(
        "/recursoshumanos/compensaciones/validationAssistanceRemote",
      );
    },
    showAlert(al) {
      console.log("al", al);
      _sTransaction.byAlert(al, this.$fun.getUserID());
      this.DocEntry = al.DocEntry;
      this.htmlComponent = al.TrsComponentName;
      this.selected = [];
      this.itemsAlert.find((x) => x.AleID == al.AleID).AleStatus = 2;
      for (let i = 0; i < this.itemsAlert.length; i++)
        if (
          this.itemsAlert[i].AleStatus == 3 ||
          this.itemsAlert[i].AleStatus == 1
        )
          this.selected.push(i);
      this.itemsAlertPending =
        this.itemsAlert != null
          ? this.itemsAlert.filter((x) => x.AleStatus == 1)
          : [];

      // Navegar a la ruta correspondiente si es HMN_BOSS_APPROVAL
      if (al.TrsComponentName === "HMN_BOSS_APPROVAL") {
        this.$router.push({
          name: "HMN_BOSS_APPROVAL",
          query: { rprID: al.DocEntry }
        });
        this.dialogNotification = false; // Cerrar el diálogo si se está abriendo la ruta
        this.dialog = false; // Cerrar el diálogo si se está abriendo la ruta
        this.notificationMenuOpen = false; // Cerrar el dropdown de notificaciones
        return;
      }

      this.dialog = true;
    },

    initialize() {
      _sAuth.initialize(this.usrID).then((response) => {
        this.userMenu = response.data.UserMenu;
        localStorage.setItem(
          "UserMenu",
          JSON.stringify(response.data.UserMenu),
        );

        this.user = response.data.User;
        this.userSAP = response.data.UserSAP;
        this.configUser = response.data.UserConfig;
        localStorage.setItem("UserInfo", JSON.stringify(response.data.User));
        localStorage.setItem(
          "UserSAPInfo",
          JSON.stringify(response.data.UserSAP || {}),
        );
        this.$nextTick().then(() => {
          require("signalr");

          //AGREGA SCRIPT DE HUBS A LA CABERA DE LA APLICACION
          let labelScript = document.createElement("script");
          labelScript.setAttribute("src", this.$const.URL + "/signalr/hubs");
          document.head.appendChild(labelScript);
          ////EVENTO CUANDO CARGA EL SCRIP DE SIGNALR
          labelScript.addEventListener("load", () => {
            $.connection.hub.url = this.$const.URL + "/signalr";

            var chat = $.connection.notification;

            chat.client.sendMessageGroup = (not, group) => {
              // 1. Emitir evento global para que componentes (Kiosco / Operador) lo reciban
              try {
                window.dispatchEvent(new CustomEvent("signalr-message-group", { detail: { message: not, group } }));
              } catch (e) {}

              // 2. Si es mensaje de firma o presencia (contiene type o batchId), no procesar como notificación de sistema
              if (!not || not.type || not.BatchId || not.batchId) {
                return;
              }

              if (group === "weeklyProjectionGroup" || not.Type === "WeeklyProjection") {
                if (not.UsrCreateID === this.$fun.getUserID()) {
                  return;
                }
                if (not.Projections && not.Projections.length > 0) {
                  this.weeklyProjectionsNotificationList = not.Projections;
                  this.dialogWeeklyProjections = true;
                  if (!this.expandedGroup) this.expandedGroup = "projections";
                }
                if (not.Name && typeof this.$push !== "undefined") {
                  this.$push.create(not.Name, {
                    body: not.Body || "",
                    icon: "/favicon.ico",
                    timeout: 15000,
                    onClick: function () {
                      window.focus();
                      this.close();
                    },
                  });
                }
                return;
              }

              let dr = {
                length: this.lengthItemsAlert,
                start: 0,
                filter: { UsrID: this.$fun.getUserID() },
              };
              _sTransaction.pagination(dr, this.$fun.getUserID()).then((r) => {
                this.itemsAlert.push(...r.data.data);
                if (this.itemsAlert.length > 0) {
                  this.itemsAlertPending.push(this.itemsAlert[0]);
                  this.itemsAlert[0].AleStatus = 3;
                }
              });

              // Refrescar notificaciones flotantes en tiempo real
              this.loadExpiredCertifications();
              this.loadExpiredContracts();
              if (not.Name && typeof this.$push !== "undefined") {
                this.$push.create(not.Name, {
                  body: not.Body || "",
                  icon: "/favicon.ico",
                  link: "www.google.com",
                  timeout: 15000,
                  onClick: function () {
                    window.focus();
                    this.close();
                  },
                });
              }
            };

            const joinGroups = () => {
              if (this.$fun.getUserInfo().CtrContract) {
                chat.invoke(
                  "addToGroup",
                  this.$fun.getUserInfo().CtrContract.PstID,
                );
              }
              chat.invoke("addToGroup", "weeklyProjectionGroup");
            };

            $.connection.hub.reconnected(() => {
              joinGroups();
            });

            $.connection.hub.disconnected(() => {
              console.log("SignalR disconnected. Reattempting start in 5 seconds...");
              setTimeout(() => {
                if ($.connection.hub.state === 4) {
                  $.connection.hub.start({ jsonp: true }).done((e) => {
                    joinGroups();
                  });
                }
              }, 5000);
            });

            $.connection.hub.start({ jsonp: true }).done((e) => {
              joinGroups();
            });
          });
        });
        if (this.user.PrsDocumentNumber != null)
          this.getImage(this.user.PrsDocumentNumber);

        if (this.configUser != null) this.GetConfigurationUser(this.configUser);
        else this.initializeConfiguration();
      });
    },
    clickNotification() {
      _sTransaction.check(this.$fun.getUserID()).then(() => {
        this.itemsAlertPending = [];
      });
    },
    // getImage(document) {
    //   _sHelper.getPhotoWorker(document, this.$fun.getUserID()).then((rsp) => {
    //     const blob = new Blob([rsp.data], {
    //       type: "image/jpg",
    //     });

    //     let image = blob;
    //     var reader = new FileReader();
    //     reader.readAsDataURL(image);
    //     reader.onloadend = () => {
    //       this.personImage = reader.result;
    //     };
    //   });
    // },
    getImage(document) {
      _sHelper
        .getPhotoWorkerBase64(document, this.$fun.getUserID())
        .then((rsp) => {
          if (rsp.status === 200 && rsp.data) {
            // Suponiendo que rsp.data ya es la cadena Base64
            this.personImage = "data:image/jpg;base64," + rsp.data;
          } else {
            console.error(
              "No se pudo obtener la imagen o la respuesta no es válida",
            );
          }
        })
        .catch((error) => {
          console.error("Error al obtener la imagen:", error);
        });
    },
    configurateActivity() {
      this.timeToken = setInterval(() => {
        if (this.usrID > 0) {
          let time = localStorage.getItem("TimeTokenCount") - 3000;
          localStorage.setItem("TimeTokenCount", time);
          if (localStorage.getItem("TimeTokenCount") < 1) {
            if (localStorage.getItem("token") != null) {
              _sAuth.refreshToken(this.usrID).then(
                (r) => {
                  localStorage.setItem(
                    "TimeTokenCount",
                    localStorage.getItem("TimeToken"),
                  );
                  localStorage.setItem("token", "");
                  localStorage.setItem("token", r.data.token);
                },
                (re) => {
                  localStorage.removeItem("token");
                },
              );
            }
          } // else clearInterval(this.timeToken);
        }
      }, 3000);

      var t;

      let logoutTimeInactive = () => {
        localStorage.setItem("isIdle", true);
        clearInterval(t);
      };

      let resetTimer = () => {
        clearInterval(t);
        localStorage.setItem("isIdle", false);
        this.timeInactiveShow = 0;
        t = setInterval(() => {
          if (this.timeInactiveShow < localStorage.getItem("TimeToken")) {
            this.timeInactiveShow = this.timeInactiveShow + 1000;
          } else {
            logoutTimeInactive();
          }
        }, 1000);
      };

      resetTimer();
      document.onload = resetTimer;
      document.onmousemove = resetTimer;
      document.onmousedown = resetTimer;
      document.ontouchstart = resetTimer;
      document.onclick = resetTimer;
      document.onscroll = resetTimer;
    },
    exit() {
      clearInterval(this.timeToken);
    },
    checkCacheRefresh() {
      const currentDate = new Date().toLocaleDateString();
      let paramRefreshLocalStorage = localStorage.getItem("paramRefresh");
      _sGenParamService
        .search({ PrmName: "ParamDeleteCache" }, this.$fun.getUserID())
        .then((resp) => {
          if (resp.data != null) {
            this.paramRefresh = resp.data.PrmValue;
            if (
              this.paramRefresh == 1 &&
              paramRefreshLocalStorage !== currentDate
            ) {
              localStorage.setItem("paramRefresh", currentDate);
              window.location.reload(true);
            } else if (
              this.paramRefresh == 0 &&
              paramRefreshLocalStorage == currentDate
            ) {
              paramRefreshLocalStorage = "";
              localStorage.removeItem("paramRefresh");
            }
          }
        })
        .catch((error) => {
          console.error(
            "Error al consultar los parámetros de configuración:",
            error,
          );
        });
    },
    openMenu(menu) {
      localStorage.setItem("NameMenuMain", menu[0]);
    },

    updateMenu(menusActive) {
      if (menusActive.length > 0) {
        menusActive = [menusActive[0]];
        let route = this.$router.options.routes[1].children.find(
          (x) => x.name == menusActive[0],
        );
        // console.log("route", route);
        if (route != undefined) this.$router.push(route.path);
        else {
          route = this.$router.options.routes.find(
            (x) => x.name == menusActive[0],
          );
          if (route != undefined) this.$router.push(route.path);
        }
      }
    },
    logout() {
      clearInterval(this.timeToken);
      localStorage.setItem("isIdle", false);
      document.onload = null;
      document.onmousemove = null;
      document.onmousedown = null;
      document.ontouchstart = null;
      document.onclick = null;
      document.onscroll = null;
      // localStorage.clear();
      const keepKeys = [
        "recordateFilters",
        "processInitial",
        "notFireWorks",
        "animate5Years",
        "filterDoll",
        "managementReportTheme",
        "vacationControlTheme",
        "workerHistoryTheme",
      ];
      const preserved = {};
      keepKeys.forEach((key) => {
        const value = localStorage.getItem(key);
        if (value !== null) preserved[key] = value;
      });
      localStorage.clear();
      Object.keys(preserved).forEach((key) => {
        localStorage.setItem(key, preserved[key]);
      });
      localStorage.removeItem("token");
      this.$router.push("/login");
    },

    setMode(mode) {
      //Dark
      if (mode) {
        this.bck_toolbar = "background:" + this.stylemodedark;
        this.class_styleCompany = "style-toolbar";
        this.icon_tlb = "color:white";
        this.bck_navigation = this.stylemodedark;
        this.icon_nav = "style-toolbar";
        this.opt_nav = "white";
        this.opt_stylenav = this.icon_tlb;
        this.darkMode = true;
      } else this.initializeConfiguration();

      //Ligth
    },
    getBackground(value) {
      if (value === true) this.bck_main = "background-dark";
      else this.bck_main = "background-light";
      this.setMode(value);
    },
    getToolbar(value) {
      if (value === this.configDefault.bck_toolbarDefault) {
        this.isToolbar = false;
        this.initializeConfiguration();
      } else {
        this.isToolbar = true;
        this.bck_toolbar = "background:" + value;
        this.class_styleCompany = "style-toolbar";
        this.icon_tlb = "color:white";
      }
    },
    getNavigation(value) {
      if (value === this.configDefault.bck_navDefault) {
        this.isNavigation = false;
        this.initializeConfiguration();
      } else {
        this.isNavigation = true;
        this.bck_navigation = value;
        this.icon_nav = "color:white";
        this.opt_nav = "white";
        this.opt_stylenav = "color:white";
        this.darkMode = true;
      }
    },
    getReset(value) {
      this.isNavigation = !value;
      this.isMode = !value;
      this.isToolbar = !value;
      this.initializeConfiguration();
    },

    initializeConfiguration() {
      //configuracion de inicio
      if (!this.isMode) {
        this.bck_main = "background-light";
        this.darkMode = false;
      }

      // toolbar
      if (!this.isToolbar) {
        this.bck_toolbar =
          "background:" + this.configDefault.bck_toolbarDefault;
        this.class_styleCompany = this.configDefault.class_styleCompanyDefault;
        this.icon_tlb = "color:" + this.configDefault.icon_tlbDefault;
      }

      // navigation
      if (!this.isNavigation) {
        this.bck_navigation = this.configDefault.bck_navDefault;
        this.icon_nav = "color:" + this.configDefault.icon_navDefault;
        this.opt_nav = this.configDefault.opt_navDefault;
        this.opt_stylenav = "color:" + this.configDefault.opt_stylenavDefault;
      }
    },

    GetConfigurationUser(value) {
      if (this.configUser != "") {
        if (
          this.configUser.CfgToolbar != null &&
          this.configUser.CfgToolbar != ""
        ) {
          this.isToolbar = true;
          this.getToolbar(this.configUser.CfgToolbar);
        } else this.isToolbar = false;

        if (this.configUser.CfgTheme != null) {
          this.bck_main =
            this.configUser.CfgTheme == 1
              ? "background-dark"
              : "background-light";

          if (this.configUser.CfgTheme == 1) {
            document
              .querySelectorAll(".theme--light.v-application")
              .forEach((el) => {
                el.style.setProperty(
                  "background",
                  "rgb(53, 54, 58)",
                  "important",
                );
              });
          } else {
            document
              .querySelectorAll(".theme--light.v-application")
              .forEach((el) => {
                el.style.setProperty("background", "#eceff1", "important");
              });
          }

          this.isMode = true;
          this.darkMode = this.configUser.CfgTheme == 1;
        } else this.isMode = false;

        if (
          this.configUser.CfgNavigation != null &&
          this.configUser.CfgNavigation != ""
        ) {
          this.isNavigation = true;
          this.getNavigation(this.configUser.CfgNavigation);
        } else this.isNavigation = false;
      }
    },

    inizializeAlerts() {
      this.itemsAlert = this.$fun.getSecurity().Alerts;
      for (let i = 0; i < this.itemsAlert.length; i++)
        if (
          this.itemsAlert[i].AleStatus == 3 ||
          this.itemsAlert[i].AleStatus == 1
        )
          this.selected.push(i);
      this.itemsAlertPending =
        this.itemsAlert != null
          ? this.itemsAlert.filter((x) => x.AleStatus == 1)
          : [];
    },
    loadExpiredCertifications() {
      _sCertificationsService
        .NotificationsExpired(this.$fun.getUserID(), this.$fun.getUserID())
        .then((response) => {
          if (response.status == 200) {
            this.expiredCertificationsList = (response.data || []).map(item => ({
              ...item,
              CertNameConcat: `${item.TypeCertificationName || ''} - ${item.TypeCertificationDetailName || ''}`.trim()
            }));
            if (this.expiredCertificationsList.length > 0) {
              this.dialogExpiredCertifications = true;
              // Si es la primera carga y no hay nada abierto, abrimos este
              if (!this.expandedGroup) this.expandedGroup = "certs";
            }
          }
        });
    },
    getDaysToExpireColor(days) {
      if (days <= 15) return "error";
      if (days <= 30) return "warning";
      if (days <= 60) return "success";
      return "info";
    },
    loadExpiredContracts() {
      _sProducerContractService
        .ExpiredContractList(this.$fun.getUserID(), this.$fun.getUserID())
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.expiredContractsList = response.data;
            if (this.expiredContractsList.length > 0) {
              this.dialogExpiredContracts = true;
            }
          }
        });
    },
    loadWeeklyProjections() {
      _sWeeklyProjectionService
        .Notifications(this.$fun.getUserID(), this.$fun.getUserID())
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.weeklyProjectionsNotificationList = response.data;
            if (this.weeklyProjectionsNotificationList.length > 0) {
              this.dialogWeeklyProjections = true;
              if (!this.expandedGroup) this.expandedGroup = "projections";
            }
          }
        });
    },
    getContractChipColor(status) {
      if (status === 1) return "error"; // Rojo
      if (status === 2) return "warning"; // Amarillo
      if (status === 3) return "success"; // Verde
      return "info";
    },
    dismissContractNotification(item) {
      this.saveNotificationStatus(item, 2); // 2 para Contratos

      this.expiredContractsList = this.expiredContractsList.filter(
        (x) => x.PctID !== item.PctID,
      );
      if (this.expiredContractsList.length === 0) {
        this.dialogExpiredContracts = false;
        if (this.expandedGroup === "contracts") this.expandedGroup = null;
      }
    },
    dismissCertNotification(item) {
      this.saveNotificationStatus(item, 1); // 1 para Certificaciones

      // Esconder de la lista actual
      this.expiredCertificationsList = this.expiredCertificationsList.filter(
        (x) => x.CrtID !== item.CrtID,
      );
      // Si no hay más, esconder el diálogo completo
      if (this.expiredCertificationsList.length === 0) {
        this.dialogExpiredCertifications = false;
        if (this.expandedGroup === "certs") this.expandedGroup = null;
      }
    },
    saveNotificationStatus(item, type) {
      const data = {
        NotID: 0,
        UsrID: this.$fun.getUserID(),
        TypeProcessNotification: type,
        ProcessID:
          type === 1
            ? item.CrtID
            : type === 3
            ? item.WptID
            : item.PctID || item.pctId || item.pctID || 0,
        Observation: "Visto desde Home",
        SecStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
      };

      _sGenNotifications.save(data, this.$fun.getUserID());
    },
    goToExpiredContracts(item = null) {
      console.log("Contrato seleccionado:", item);
      if (!item) {
        this.expandedGroup = this.expandedGroup === "contracts" ? null : "contracts";
        return;
      }

      // Intentar obtener el ID de varias formas por si el backend lo manda distinto
      const pctId = item === "all" ? null : (item.PctID || item.pctId || item.pctID);

      if (item && item !== "all") {
        this.saveNotificationStatus(item, 2);
        this.expiredContractsList = this.expiredContractsList.filter(
          (x) => (x.PctID || x.pctId || x.pctID) !== pctId,
        );
        if (this.expiredContractsList.length === 0) {
          this.dialogExpiredContracts = false;
          if (this.expandedGroup === "contracts") this.expandedGroup = null;
        }
      }
      this.expandedGroup = null;

      this.$router.push({
        name: "TAS_PRODUCER_CONTRACT",
        query: pctId ? { PctID: pctId } : {},
      });
    },
    goToExpiredCertifications(item = null) {
      if (!item) {
        this.expandedGroup = this.expandedGroup === "certs" ? null : "certs";
        return;
      }

      if (item && item !== "all") {
        this.saveNotificationStatus(item, 1);

        // Esconder de la lista actual
        this.expiredCertificationsList = this.expiredCertificationsList.filter(
          (x) => x.CrtID !== item.CrtID,
        );
        // Si no hay más, esconder el diálogo completo
        if (this.expiredCertificationsList.length === 0) {
          this.dialogExpiredCertifications = false;
          if (this.expandedGroup === "certs") this.expandedGroup = null;
        }
      }

      // Minimizar siempre al seleccionar una o al ir a "Ver todo"
      this.expandedGroup = null;

      const crtId = item === "all" ? null : item.CrtID;
      this.$router.push({
        name: "TAS_CERTIDICATION_EXPIRATION",
        query: crtId ? { CrtID: crtId } : {},
      });
    },
    goToWeeklyProjections(item = null) {
      if (!item) {
        this.expandedGroup = this.expandedGroup === "projections" ? null : "projections";
        return;
      }

      if (item && item !== "all") {
        this.saveNotificationStatus(item, 3); // 3 para Proyecciones Semanales

        // Esconder de la lista actual
        this.weeklyProjectionsNotificationList = this.weeklyProjectionsNotificationList.filter(
          (x) => x.WptID !== item.WptID,
        );
        if (this.weeklyProjectionsNotificationList.length === 0) {
          this.dialogWeeklyProjections = false;
          if (this.expandedGroup === "projections") this.expandedGroup = null;
        }
      }

      this.expandedGroup = null;
      this.dialogWeeklyProjections = false;
      this.$router.push({
        name: "ATS_WEEKLY_SCREENINGS",
      });
    },
    dismissProjectionNotification(item) {
      this.saveNotificationStatus(item, 3); // 3 para Proyecciones Semanales

      this.weeklyProjectionsNotificationList = this.weeklyProjectionsNotificationList.filter(
        (x) => x.WptID !== item.WptID,
      );
      if (this.weeklyProjectionsNotificationList.length === 0) {
        this.dialogWeeklyProjections = false;
        if (this.expandedGroup === "projections") this.expandedGroup = null;
      }
    },
    handleScroll: function (el) {
      if (
        el.srcElement.offsetHeight + el.srcElement.scrollTop >=
        el.srcElement.scrollHeight
      ) {
        let dr = {
          length: this.lengthItemsAlert,
          start: this.indexAlert * this.lengthItemsAlert,
          filter: { UsrID: this.$fun.getUserID() },
        };

        _sTransaction.pagination(dr, this.$fun.getUserID()).then((r) => {
          this.itemsAlert.push(...r.data.data);
        });
      }
    },
    startSlider() {
      this.playCurrentItem();
    },

    playCurrentItem() {
      // Si playSoloVideo es true, solo reproducir el video en bucle
      if (this.playSoloVideo) {
        const videoItem = this.images.find((item) => item.isVideo);
        if (videoItem) {
          const videoIndex = this.images.indexOf(videoItem);
          if (this.currentIndex !== videoIndex) {
            this.currentIndex = videoIndex;
          }

          this.$nextTick(() => {
            const videoElement = this.$el.querySelector(".slider-video");
            if (videoElement) {
              videoElement.loop = true;
              videoElement.onended = null; // Eliminamos el handler de ended
              videoElement
                .play()
                .catch((e) => console.error("Error al reproducir video:", e));
            }
          });
        }
        return; // Salimos del método sin continuar con el flujo normal
      }

      // Flujo normal (cuando playSoloVideo es false)
      const currentItem = this.images[this.currentIndex];

      if (currentItem.isVideo && !this.playVideo) {
        this.nextImageAfterDelay(0);
        return;
      }

      if (currentItem.isVideo) {
        this.$nextTick(() => {
          const videoElement = this.$el.querySelector(".slider-video");
          if (videoElement) {
            videoElement.loop = false;
            videoElement.onended = this.handleVideoEnded;
            videoElement.play().catch((e) => {
              console.error("Error al reproducir video:", e);
              this.nextImageAfterDelay(1000);
            });
          } else {
            this.nextImageAfterDelay(1000);
          }
        });
      } else {
        this.nextImageAfterDelay(this.intervalTime);
      }
    },

    handleVideoEnded() {
      // Cuando el video termina, pasar al siguiente
      this.nextImageAfterDelay(0);
    },

    nextImageAfterDelay(delay) {
      if (this.playSoloVideo) return;

      this.clearInterval();
      this.interval = setTimeout(() => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
        this.playCurrentItem();
      }, delay);
    },

    pauseSlider() {
      this.clearInterval();
      const currentItem = this.images[this.currentIndex];
      this.pausedImageSrc = currentItem.src;

      // Pausar video si está reproduciéndose
      if (currentItem.isVideo) {
        const videoElement = this.$el.querySelector(".slider-video");
        if (videoElement) {
          videoElement.pause();
        }
      }
    },

    resumeSlider() {
      if (this.playSoloVideo) {
        const videoElement = this.$el.querySelector(".slider-video");
        if (videoElement) {
          videoElement
            .play()
            .catch((e) => console.error("Error al reanudar video:", e));
        }
        return;
      }

      // Resto de la lógica normal...
      const currentItem = this.images[this.currentIndex];
      if (currentItem.isVideo && !this.playVideo) {
        this.nextImageAfterDelay(0);
        return;
      }

      if (currentItem.isVideo) {
        const videoElement = this.$el.querySelector(".slider-video");
        if (videoElement) {
          videoElement
            .play()
            .catch((e) => console.error("Error al reanudar video:", e));
        }
      } else {
        this.playCurrentItem();
      }
    },

    clearInterval() {
      if (this.interval) {
        clearTimeout(this.interval);
        this.interval = null;
      }
    },
    openDialog() {
      this.dialogImg = true;
    },
    animateFinalName() {
      const target = this.finalName.split("");
      this.animatedName = "";
      let i = 0;
      const interval = setInterval(() => {
        if (i < target.length) {
          this.animatedName += target[i];
          i++;
        } else {
          clearInterval(interval);
          this.showHat = true;
        }
      }, 150);
    },
    updateIsMobile() {
      this.$forceUpdate();
    },
  },
  watch: {
    $route(to, from) {
      this.inizializeAlerts();
    },
    playSoloVideo(newVal) {
      this.clearInterval(); // Limpiamos cualquier intervalo existente

      if (newVal) {
        // Buscar el video y reproducirlo en bucle
        const videoIndex = this.images.findIndex((item) => item.isVideo);
        if (videoIndex >= 0) {
          this.currentIndex = videoIndex;
          this.playCurrentItem();
        }
      } else {
        // Volver al flujo normal
        this.playCurrentItem();
      }
    },
  },
  computed: {
    timeShow() {
      return (
        parseInt(
          Math.round(
            (localStorage.getItem("TimeToken") - this.timeInactiveShow) / 60000,
          ),
        ).toString() + " min"
      );
    },
    isIdle() {
      return localStorage.isIdle;
    },
    currentImage() {
      return this.images[this.currentIndex];
    },
    renderedFinal() {
      return this.animatedName.split("");
    },
    isMobile() {
      return window.innerWidth < 1000;
    },
  },

  mounted() {
    this.baseUrl = this.$const.BASEURL;
    this.currentWeek = DateTime.now().weekNumber;

    _sGenParamService
      .search({ PrmName: "showWeekNumber" }, this.$fun.getUserID())
      .then((resp) => {
        if (resp.data != null) {
          this.showWeekNumber = parseInt(resp.data.PrmValue) || 0;
        }
      });

    _sGenParamService
      .search({ PrmName: "responsableturnonoche" }, this.$fun.getUserID())
      .then((resp) => {
        if (resp.data != null) {
          this.personNight = resp.data.PrmValue || "sa";
        }
      });

    // _sGenParamService.search(
    //   { PrmName: "playVideoSunExpert" },
    //   this.$fun.getUserID(),
    // )
    //   .then(resp => {
    //     if (resp.data != null) {
    //       this.playVideo = parseInt(resp.data.PrmValue) || 0;
    //     }
    //   });

    // _sGenParamService.search(
    //   { PrmName: "playSoloVideoSunExpert" },
    //   this.$fun.getUserID(),
    // )
    //   .then(resp => {
    //     if (resp.data != null) {
    //       this.playSoloVideo = parseInt(resp.data.PrmValue) || 0;
    //       console.log(this.playSoloVideo);
    //     }
    //   });

    // _sGenParamService.search(
    //   { PrmName: "bgHeaderSunExpertStatico" },
    //   this.$fun.getUserID(),
    // )
    //   .then(resp => {
    //     if (resp.data != null) {
    //       this.bgHeaderSunExpertStatico = parseInt(resp.data.PrmValue) || 0;
    //     }
    //   });

    // _sGenParamService.search(
    //   { PrmName: "background-ViewSE" },
    //   this.$fun.getUserID(),
    // )
    //   .then(resp => {
    //     if (resp.data != null) {
    //       this.bgHomeFiestasPatrias = parseInt(resp.data.PrmValue) || 0;
    //     }
    //   });

    // _sGenParamService.search(
    //   { PrmName: "sunshineExportHalloween" },
    //   this.$fun.getUserID(),
    // )
    // .then(resp => {
    //   if(resp.data != null)
    //   {
    //     this.sunshineExportHalloween = parseInt(resp.data.PrmValue) ||0;
    //   }
    // });

    // _sGenParamService.search(
    //   { PrmName: "sunshineExportNavidad" },
    //   this.$fun.getUserID(),
    // )
    // .then(resp => {
    //   if(resp.data != null)
    //   {
    //     this.sunshineExportNavidad = parseInt(resp.data.PrmValue) ||0;
    //   }
    // });

    // setInterval(() => {
    //   this.checkCacheRefresh();
    // }, 700); // 10 minutos = 600000
    this.startSlider();
  },
  beforeDestroy() {
    this.clearInterval();
    window.removeEventListener("resize", this.updateIsMobile);
  },
};
</script>
<style scoped>
.slider-container {
  overflow: hidden;
  width: 100%;
  max-width: 310px;
  position: relative;
  height: 430px;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  padding: 5px;
  background-color: #fff;
  margin-bottom: 15px;
}

.slider-wrapper.video-active {
  background-color: #e22825;
}

.slider-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.slider {
  position: relative;
  width: 100%;
  height: 100%;
}

.slider-image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
  z-index: 100;
}

.slider-video {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  /* transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out; */
  z-index: 1;
  object-fit: cover;
  /* border-radius: 50%; */
}

/* Animación de entrada desde la derecha */
.slide-enter-active {
  transform: translateX(0%);
  opacity: 1;
}

.slide-enter {
  transform: translateX(100%);
  opacity: 0;
}

/* Animación de salida hacia la izquierda */
.slide-leave-active {
  transform: translateX(-100%);
  opacity: 0;
}

.background-light {
  background: #eceff1 !important;
}

.background-dark {
  background: rgb(53, 54, 58) !important;
}

.style-toolbar {
  color: white;
  font-size: 12px !important;
}

.style-font {
  color: white;
  font-size: 12px !important;
}

.style-default {
  font-weight: 400 !important;
  font-size: 12px !important;
}

.gorro {
  width: 15px;
  height: 15px;
  /* You must set a specified height */
  margin-right: auto;
  position: absolute;
  display: inline;
  margin-top: -10px;
  margin-left: -12px;
  background-image: url("https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/2708147a-9e73-4d2e-a640-764f7a1be2ec/d5mxuaf-44e08c01-bd7f-4920-91ce-4c3d8bb3d045.png/v1/fill/w_500,h_383,strp/gorro_de_navidad_png_by_chequealostutoriales_d5mxuaf-fullview.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzgzIiwicGF0aCI6IlwvZlwvMjcwODE0N2EtOWU3My00ZDJlLWE2NDAtNzY0ZjdhMWJlMmVjXC9kNW14dWFmLTQ0ZTA4YzAxLWJkN2YtNDkyMC05MWNlLTRjM2Q4YmIzZDA0NS5wbmciLCJ3aWR0aCI6Ijw9NTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.KWNgxPGOFOwouMuNnzGCA7TFsKsb0tGphGxNdNYf_WU");

  background-position: center;
  /* Center the image */
  background-repeat: no-repeat;
  /* Do not repeat the image */
  background-size: cover;
  /* Resize the background image to cover the entire container */
  transform: scaleX(-1) rotate(10deg);
}

.image-container {
  position: absolute;
  bottom: 0;
  /* Imagen en la parte inferior si no hay scroll */
  left: 0;
  width: 100%;
  max-width: 280px;
  max-height: 400px;
}

.v-navigation-drawer {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100vh;
}

.scroll {
  overflow-y: auto;
  /* Permitir scroll si el contenido es largo */
}

.v-treeview {
  min-height: 46vh;
}

@media (max-height: 800px) {
  .v-treeview {
    min-height: 24vh;
    /* Adjust to smaller value */
  }
}

.trineo-container {
  position: absolute;
  bottom: 0px;
  left: 0;
  z-index: 101;
  width: 100%;
  height: 50px;
}

.trineo-img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100px;
  animation: move-trineo 15s linear infinite;
}

@keyframes move-trineo {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(100vw);
  }
}

/* Floating Notifications System Stack */
.notif-stack-container {
  position: fixed;
  bottom: 12px;
  right: 12px;
  z-index: 10000;
  display: flex;
  flex-direction: column-reverse; /* Las notificaciones nuevas aparecen abajo */
  align-items: flex-end;
  pointer-events: none; /* Para que no bloquee clicks fuera de las tarjetas */
}

.notif-stack-container > * {
  pointer-events: auto; /* Re-habilitar clicks dentro de las tarjetas */
}

/* Semana actual pulse animation */
.week-chip-pulse {
  animation: week-pulse 2.5s infinite ease-in-out;
}

@keyframes week-pulse {
  0% {
    transform: scale(1);
    opacity: 0.95;
  }
  50% {
    transform: scale(1.03);
    opacity: 1;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  }
  100% {
    transform: scale(1);
    opacity: 0.95;
  }
}
</style>
